export default "__VITE_ASSET__5a59bab2__"